import { gql } from '@apollo/client';

export const GET_DAILYCHIRP_WITH_DATA_QUERY = gql`
  query GetDailychirpWithData($hotelId: ID!, $date: Date) {
    dailychirps(where: { hotel: $hotelId, date: $date }, limit: 1) {
      id
      date
      title
      dailybirdData
      pdfDocuments
    }
  }
`;
